import { render, staticRenderFns } from "./visa_exemption.vue?vue&type=template&id=dff8d65a&"
import script from "./visa_exemption.vue?vue&type=script&lang=js&"
export * from "./visa_exemption.vue?vue&type=script&lang=js&"
import style0 from "./visa_exemption.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports